import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ToastController,
  App,
} from 'ionic-angular';
import { ContactRequestProvider } from '../../providers/contact-request/contact-request';
import { User } from '../../providers/user/user';

/**
 * Generated class for the ContactRequestPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  defaultHistory: ["HomePage"]
})
@Component({
  selector: 'page-contact-request',
  templateUrl: 'contact-request.html',
})
export class ContactRequestPage {
  contactRequests: any[] = [];

  constructor(
    private app: App,
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    private contactRequestProvider: ContactRequestProvider,
    private userProvider: User
  ) {}

  ionViewDidLoad() {
    this.getContactRequests();
  }

  getContactRequests(): void {
    this.contactRequestProvider.allContactRequest().subscribe(requests => {
      this.contactRequests = requests;
    });
  }

  viewProfile(userId: string): void {
    if ( userId !== this.userProvider.currentUser().uuid) {
      this.app.getRootNav().push('ProfilePage', {
        userId: userId,
      });
    }
  }
  acceptContactRequest(userId: string): void {
    this.contactRequestProvider.acceptContactRequest(userId).subscribe(resp => {
      this.toastCtrl
        .create({
          message: 'You have a new contact go and say HI to them!',
          duration: 3000,
          position: 'top',
        })
        .present();
      this.contactRequests = this.contactRequests.map(
        item => {
          if (item.uuid === userId) {
            item.isAccepted = true;
          }
          return item;
        }
      );

    });
  }

  rejectContactRequest(userId: string): void {
    this.contactRequestProvider.cancelContactRequest(userId).subscribe(resp => {
      this.toastCtrl
        .create({
          message: 'Contact request successfully removed!',
          duration: 3000,
          position: 'top',
        })
        .present();
      this.contactRequests = this.contactRequests.filter(
        item => item.uuid !== userId
      );
    });
  }

  goToContacts() {
    this.navCtrl.push('MessengerPage', {
      events: 'contacts',
    });
  }

  viewMessages(userId: string): void {
    this.navCtrl.pop();
    this.navCtrl.push('MessagePage', {
      userId: userId,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact-request/contact-request.ts